// src/api/watchFindings.js
// E5a — die Liste des nächtlichen Preis-Prüfers. Backend:
// backend/scrapers/routes.py §watch-findings (Migration 225).
// Siehe docs/features/scraper.md und
// docs/superpowers/plans/2026-08-15-e5a-naechtlicher-pruefer.md.
import { api } from './client';

/**
 * 🔴 `admin_sync_runs.summary` ist VERPACKT, und die Seite darf das nicht wissen müssen.
 *
 * `cron_run_context.record_summary` (`backend/notify/cron_runner.py`) schreibt
 * **unbedingt** `{items_processed, items_failed, extras}` — die Kennzahlen des
 * Läufers landen also unter `extras`, nicht auf der obersten Ebene. Gemessen an
 * einer echten Prod-Zeile (`kind='cron-scraper'`): die Schlüssel sind
 * `['extras', 'items_failed', 'items_processed']`.
 *
 * Die erste Fassung der Seite las eine Ebene zu hoch. Wirkung: **jedes** Feld
 * war `undefined` und fiel auf `0` / `'?'` zurück — ein übersprungener Lauf
 * hätte als unauffälliger Erfolg mit „nicht vergleichbar: 0" gerendert. Also
 * genau die Entwarnung, gegen die diese Seite gebaut ist, erzeugt von der Seite
 * selbst. Vom Regel-15-Gate gefunden.
 *
 * ⚠️ Und der Playwright-Test hat es NICHT gefunden, weil seine Vorrichtung
 * dieselbe falsche Annahme traf: er stubbte `summary` flach. Ein Test, der die
 * Annahme der Fläche teilt, prüft sie nicht — er bestätigt sie (Regel 17 §2).
 *
 * Das Auspacken steht deshalb HIER, an einer Stelle, mit Namen — nicht verstreut
 * in der Ansicht. `items_processed`/`items_failed` bleiben erhalten, falls sie
 * jemand braucht.
 */
function entpackeLauf(lauf) {
  if (!lauf) return lauf;
  const roh = lauf.summary || {};
  const verpackt = Object.prototype.hasOwnProperty.call(roh, 'extras');
  return {
    ...lauf,
    summary: verpackt ? { ...roh, ...(roh.extras || {}) } : roh,
  };
}

export function listWatchFindings({ state = 'open', days = 7, limit = 200 } = {}) {
  return api
    .get('/api/scrapers/watch-findings', { params: { state, days, limit } })
    .then((r) => ({ ...r.data, last_run: entpackeLauf(r.data?.last_run) }));
}

export function setWatchFindingState(id, state) {
  return api
    .patch(`/api/scrapers/watch-findings/${id}`, { state })
    .then((r) => r.data);
}
